import React, { useEffect, useState } from 'react';

function Switcher({ boxed = false }) {
  const [stylePath, setStylePath] = useState('./assets/css/skin/skin-1.css');

  useEffect(() => {
    if (boxed) {
      document.body.classList.add('boxed');
      document.body.classList.add('bg-repeat');
      document.body.id = 'bg';
    } else {
      document.body.classList.remove('boxed');
      document.body.classList.remove('bg-repeat');
      document.body.id = '';
      document.body.style.backgroundImage = '';
    }
    setStylePath('./assets/css/skin/skin-1.css');
  }, [boxed]);

  return (
    <>
      <link rel="stylesheet" type="text/css" href={stylePath} />
    </>
  );
}

export default Switcher;
